"use strict";Object.defineProperty(exports, "__esModule", {value: true});


var _UCZW3OGHcjs = require('./UCZW3OGH.cjs');


var _PTOCUU2Dcjs = require('./PTOCUU2D.cjs');

// src/toolbar/toolbar-context.tsx
var ctx = _PTOCUU2Dcjs.createStoreContext.call(void 0, 
  [_UCZW3OGHcjs.CompositeContextProvider],
  [_UCZW3OGHcjs.CompositeScopedContextProvider]
);
var useToolbarContext = ctx.useContext;
var useToolbarScopedContext = ctx.useScopedContext;
var useToolbarProviderContext = ctx.useProviderContext;
var ToolbarContextProvider = ctx.ContextProvider;
var ToolbarScopedContextProvider = ctx.ScopedContextProvider;







exports.useToolbarContext = useToolbarContext; exports.useToolbarScopedContext = useToolbarScopedContext; exports.useToolbarProviderContext = useToolbarProviderContext; exports.ToolbarContextProvider = ToolbarContextProvider; exports.ToolbarScopedContextProvider = ToolbarScopedContextProvider;
